import { sum } from './sum';

/**
 * Returns a key based on the weighted likelihood given in the values of an object.
 * ```typescript
 *   weightedSample({ a: 1, b: 1, c: 5 }); // 'c' about 5/7 of the time.
 * ```
 */
export function weightedSample<T extends string | number | symbol>(weights: Record<T, number>): T {
  const keys = Object.keys(weights) as T[];
  const values = Object.values(weights) as number[];
  const totalWeight = values.reduce(sum, 0);

  // Pick a number in the range of totalWeight:
  const weight = Math.random() * totalWeight;

  // Now find the winning key:
  return keys.find((key, index) => {
    const accumulatedWeight = values.slice(0, index + 1).reduce(sum, 0);
    if (weight <= accumulatedWeight || index === keys.length - 1) return true;
    return false;
  })!;
}
